import { useGetApprovalConfigurationQuery } from '../../../__generated__/chirp/com/hubspot/product/approvals/rpc/ApprovalsConfigurationRpc.hooks';
import { APP_GOVERNANCE_APPROVAL_ACTION, APP_GOVERNANCE_APPROVAL_TYPE } from '../constants';
//Checks if portal is enabled for Product Approvals
export function useGetProductApprovalConfiguration() {
  const {
    data,
    loading,
    error,
    refetch
  } = useGetApprovalConfigurationQuery({
    variables: {
      approvalType: APP_GOVERNANCE_APPROVAL_TYPE,
      approvalAction: APP_GOVERNANCE_APPROVAL_ACTION
    }
  });
  const configurationEnabled = data === null || data === void 0 ? void 0 : data.approvalConfiguration.approvalConfigured;
  return {
    enabled: configurationEnabled === undefined ? false : configurationEnabled,
    loading,
    error,
    refetch
  };
}